<template>
  <article
    v-inview:class="['animate']"
    :class="getVariant('services-item')"
    class="services-item"
  >
    <!-- Icon -->
    <figure class="services-item__icon">
      <slot name="icon" />
    </figure>

    <!-- Title -->
    <div class="services-item__title">
      <slot name="title" />
    </div>

    <!-- Content -->
    <div class="services-item__content">
      <slot name="content" />
    </div>
  </article>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'ServicesItem',

  mixins: [variant]
};
</script>

<style lang="scss" src="@/assets/components/services/services-item-view.scss"></style>



// WEBPACK FOOTER //
// services-item-view.vue